import { useRef } from 'react';
import Button from '../Button/Button';
import './ImageUpload.css';

const ImageUpload = ({ previewSrc, onSelect, onRemove, disabled, hint = 'PNG, JPG, WEBP' }) => {
  const fileInputRef = useRef(null);
  const openPicker = () => fileInputRef.current?.click();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    e.target.value = '';
    if (file) onSelect(file);
  };

  return (
    <div className="image-upload-area" onClick={previewSrc || disabled ? undefined : openPicker}>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        className="image-upload-hidden-input"
        onChange={handleFileChange}
        disabled={disabled}
      />
      {previewSrc ? (
        <>
          <img src={previewSrc} alt="preview" className="image-upload-preview" />
          <div className="image-upload-actions">
            <Button variant="secondary" size="sm" onClick={openPicker} disabled={disabled}>
              Change
            </Button>
            <Button variant="secondary" size="sm" danger onClick={onRemove} disabled={disabled}>
              Remove
            </Button>
          </div>
        </>
      ) : (
        <>
          <span className="material-symbols-outlined">upload</span>
          <p>Click to upload an image</p>
          <span className="image-upload-hint">{hint}</span>
        </>
      )}
    </div>
  );
};

export default ImageUpload;
